"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Toggle = require("./Toggle");

var _Toggle2 = _interopRequireDefault(_Toggle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Toggle2.default;